import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map } from 'rxjs';

import { USER_SERVICE } from '../../tokens/user-service.token';

import { UserListStateActions } from './user-list-state.actions';

@Injectable()
export class UserListStateEffects {
  private action$ = inject(Actions);

  private readonly userService = inject(USER_SERVICE);

  $getUserList = createEffect(() =>
    this.action$.pipe(
      ofType(UserListStateActions.getUserList),
      concatMap(() => this.userService.getUserList({})),
      map(userList => UserListStateActions.getUserListSuccess({ users: userList }))
    )
  );
}
